import { Navigate, Route, Routes } from 'react-router-dom';

import AppLayout from '../ui/Layout/AppLayout';
import { OverviewContainer } from './Account';

const AccountContainer = () => (
  <AppLayout>
    <Routes>
      <Route path="overview/*" element={<OverviewContainer />} />
      <Route index element={<Navigate to="overview" replace />} />
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  </AppLayout>
);

AccountContainer.propTypes = {};

export default AccountContainer;
